/**
 * A 页面如下 调用 。
 * wxBridge.dispatchEvent({
                eventName: "__followEvent__",
                appId: 'wx62d9035fd4fd2059',
                data: {
                    followWhich : whichCircle,
                    isFollowed  : followed
                }
            }, function(res) {
                //todo，要做一下slstart
                console.error(res);
            });
 * B 页面如下监听
 * wxBridge.on('__followEvent__', function(res) {
 *      res = {
 *              data: {
                    followWhich : whichCircle,
                    isFollowed  : followed
                }}
                
        }.bind(this));
 */
import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.dispatchEvent = wxBridge.dispatchEvent || function(param, callback) {
    wxBridge.invoke('dispatchEvent', param, callback);
};

export default wxBridge;

export const {
    dispatchEvent
} = wxBridge;
